import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import store from '@/store';

const {
  VUE_APP_API_HOST: host,
  VUE_APP_API_PORT: port,
} = process.env;

const api = axios.create({
  baseURL: `${host}:${port}/api/v1`,
});

const abortController = new AbortController();
api.defaults.signal = abortController.signal;

api.interceptors.request.use(async (config) => {
  const customHeaders = {};
  const empresasSelecionadas = store.getters['Auth/getEmpresasSelecionadas'];

  if (empresasSelecionadas) {
    customHeaders['X-Empresas-Selecionadas'] = empresasSelecionadas;
  }

  if (localStorage.getItem('token:@CTRL')) {
    customHeaders.Authorization = localStorage.getItem('token:@CTRL');
  }

  Object.assign(config.headers, customHeaders);

  return config;
}, (error) => {
  Promise.reject(error);
});

api.interceptors.response.use((response) => response, (error) => {
  if (error?.response?.status === 401) {
    localStorage.removeItem('token:@CTRL');
    const { pathname, search } = window.location;
    const rotasAbertas = [
      '/login',
      '/esqueci-minha-senha',
      '/recuperar-senha',
      '/manutencao',
      '/privacidade',
    ];

    if (!rotasAbertas.includes(pathname)) {
      router.push({
        name: 'Login',
        params: {
          redirect: `${pathname}${search}`,
        },
      });
    }
  } else if (error?.response?.status === 403 && error?.response?.data.tipo === 'CLIENTE_CONSULTOR') {
    const { pathname, search } = window.location;

    router.push({
      name: 'processosParceiros',
      params: {
        redirect: `${pathname}${search}`,
      },
    });
  } else {
    throw error;
  }
});

export default api;
